export default __webpack_public_path__ + "static/N0049-e1727e54799fe13472ff3c12a81c1938.png";